export default [
  {
    path: "/",
    name: "/",
    component: () => import("@/views/guide-page"),
    meta: {
      title: "智慧心育"
    }
  },
  {
    // 引导页
    path: "/guidePage",
    name: "/",
    component: () => import("@/views/guide-page"),
    meta: {
      title: "智慧心育"
    }
  },
  {
    // 知识图谱
    path: "/knowledge",
    name: "/",
    component: () => import("@/views/knowledge-structure"),
    meta: {
      title: "智慧心育"
    }
  },
  // {
  //   path: "/knowledge",
  //   name: "/",
  //   component: () => import("@/views/knowledge-structure"),
  //   meta: {
  //     title: "智慧心育"
  //   }
  // },
  {
    // 学生画像-干预前
    path: "/studentPre",
    name: "/",
    component: () => import("@/views/student-pic-pre"),
    meta: {
      title: "智慧心育"
    }
  },
  {
    // 学生画像-干预后
    path: "/studentAfter",
    name: "/",
    component: () => import("@/views/student-pic-after"),
    meta: {
      title: "智慧心育"
    }
  },
  {
    // 互动测评
    path: "/interactive",
    name: "/",
    component: () => import("@/views/question-interactive"),
    meta: {
      title: "智慧心育"
    }
  },
  {
    // 干预练习
    path: "/exercise",
    name: "/",
    component: () => import("@/views/intervention-exercise"),
    meta: {
      title: "智慧心育"
    }
  },
  {
    // 学校画像
    path: "/school",
    name: "/",
    component: () => import("@/views/school-pic"),
    meta: {
      title: "智慧心育"
    }
  },
  {
    // 心育资源库
    path: "/curriculumResource",
    component: () => import("@/views/curriculum/curriculumResource.vue"),
    meta: {
      topbar: "curriculum",
      title: "智慧心育",
    },
  },
  {
    // 心育资源详情
    path: "/curriculumDetail",
    component: () => import("@/views/curriculum/curriculumDetail.vue"),
    meta: {
      topbar: "curriculum",
      title: "智慧心育",
    },
  },
  {
    //  测评报告
    path: "/evaluationReport",
    name: "/",
    component: () => import("@/views/evaluation-report"),
    meta: {
      title: "智慧心育"
    }
  },
  // 量表列表
  {
    path: "/measure/inventoryList",
    component: () => import("../views/measurement/index.vue"),
    children: [
      {
        path: "/measure/inventoryList",
        component: () => import("../views/measurement/inventoryList.vue"),
        meta: {
          topbar: "measurement",
          foldbar: "list",
          leftbar: "list",
          title: "心理测评-量表列表",
        },
      },
      {
        path: "/measure/taskManagement/list",
        component: () => import("../views/measurement/taskManagement.vue"),
        meta: {
          topbar: "measurement",
          foldbar: "task",
          leftbar: "task",
          title: "心育测评-任务管理",
        },
      },
      {
        path: "/measure/crisisWarning",
        component: () => import("../views/measurement/crisisWarning.vue"),
        meta: {
          topbar: "measurement",
          foldbar: "crisis",
          leftbar: "crisis",
          title: "心育测评-预警关注",
        },
      },
      {
        path: "/measure/reportManagement",
        component: () =>
          import("../views/measurement/reportManagement.vue"),
        meta: {
          topbar: "measurement",
          foldbar: "reportParent",
          leftbar: "report",
          title: "心育测评-报告管理",
        },
      },
    ]
  },
  {
    //  学生成长档案
    path: "/growthPortfolio",
    name: "/",
    component: () => import("@/views/growth-portfolio"),
    meta: {
      title: "智慧心育",
      topbar: "psychic",
    }
  },
];
